module.exports = __webpack_public_path__ + "static/img/cet-bg.9d2e053.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cet-bg.png
// module id = Hp2m
// module chunks = 1